import React from 'react';
import { Menu, Building2 } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import LanguageToggle from './LanguageToggle';
import { API_URL } from '../utils/api';

/**
 * The sticky 56px bar that replaces the sidebar header on a phone.
 *
 * `currentBranch` is passed straight through to `LanguageToggle`, which reads
 * `currentBranch?.branch_id` and saves nothing without it - dropping this
 * prop would leave the toggle on screen but silently non-functional, same as
 * in `NavDrawer`.
 */
const MobileHeader = ({ title, onOpenDrawer, user, currentBranch }) => {
  const { print_lang } = useLanguage();

  return (
    <header className="mobile-header">
      <button
        type="button"
        className="mobile-header-menu"
        onClick={onOpenDrawer}
        aria-label={print_lang('menu', 'Menu')}
      >
        <Menu size={20} aria-hidden="true" />
      </button>

      <h1 className="mobile-header-title">{title}</h1>

      <div className="mobile-header-right">
        <LanguageToggle currentBranch={currentBranch} />

        {currentBranch ? (
          currentBranch.logo_path ? (
            <img
              src={currentBranch.logo_path.startsWith('http') ? currentBranch.logo_path : `${API_URL}/${currentBranch.logo_path}`}
              alt={currentBranch.name}
              className="mobile-header-branch-logo"
            />
          ) : (
            <div className="mobile-header-branch-chip" title={currentBranch.name}>
              <Building2 size={16} aria-hidden="true" />
            </div>
          )
        ) : (
          <div className="mobile-header-avatar">
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
        )}
      </div>
    </header>
  );
};

export default MobileHeader;
